import { forwardRef, type Ref, type SVGProps } from "react";
const IconGlobeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m1 7V4.06h.75c.37.06.75.13 1.12.22h.18A11.6 11.6 0 0 1 21.84 9zm-6.84 0A11.6 11.6 0 0 1 13 4.41h.18c.37-.09.75-.16 1.12-.22h.75V9zM24 9a18 18 0 0 0-1.24-2.94 12 12 0 0 1 3 2.94zM6.27 9a12 12 0 0 1 3-2.94A18 18 0 0 0 8.05 9zM25 15a24 24 0 0 0-.49-4h2.41A12 12 0 0 1 28 15zm-8 0v-4h5.43a22 22 0 0 1 .57 4zm-8 0a22 22 0 0 1 .53-4H15v4zm-5 0a12 12 0 0 1 1.06-4h2.46A24 24 0 0 0 7 15zm20.43 6a24 24 0 0 0 .57-4h3a12 12 0 0 1-1.06 4zM17 21v-4h6a22 22 0 0 1-.53 4zm-7.43 0A22 22 0 0 1 9 17h6v4zm-4.46 0a12 12 0 0 1-1.06-4H7a24 24 0 0 0 .49 4zm17.6 4.94A18 18 0 0 0 24 23h1.78a12 12 0 0 1-3 2.94zm-5.71 2V23h4.84a11.6 11.6 0 0 1-2.79 4.59l-.18.05c-.37.09-.75.16-1.12.22l-.33.05H17zm-2 0h-.42l-.33-.05c-.37-.06-.75-.13-1.12-.22l-.13-.08A11.6 11.6 0 0 1 10.16 23H15zm-5.71-2a12 12 0 0 1-3-2.94h1.76a18 18 0 0 0 1.24 2.94" />
  </svg>
);
const ForwardRef = forwardRef(IconGlobeOutlineSVG);
ForwardRef.displayName = "IconGlobeOutline";
export { ForwardRef as IconGlobeOutline };
